import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { WindowSizeService } from '@ally/remarketing/shared/services';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MobileOnlyGuard  {
  constructor(private readonly windowSizeService: WindowSizeService, private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.windowSizeService.windowSize$().pipe(
      map(size => {
        if (size.isDesktop()) {
          return this.router.createUrlTree(['profile-management/contact-information']);
        }
        return true;
      })
    );
  }
}
